import {createSvgIcon} from '../create-svg-icon';

export const ForwardIcon = createSvgIcon(
  <path d="M14 8.83 17.17 12 14 15.17V14H6v-4h8V8.83M12 4v4H4v8h8v4l8-8-8-8z" />
, 'ForwardOutlined');
